let axiosUrl = "";

if (process.env.NODE_ENV === "development") {
  // axiosUrl = "http://debug.gree.com/apisix";
  axiosUrl = "/api";
  // axiosUrl = "https://zhaopin.greeyun.com/api/";
} else {
  axiosUrl = window.location.origin + "/api";
}

export { axiosUrl };
